// extracted by mini-css-extract-plugin
module.exports = {"clickable_label_fix":"arbeidsongeschiktheid_clickable_label_fix__2JlTN"};